<template>
	<div id="printSection" class="printSection flex flex-col gap-5">
		<div class="mb-8 text-center">
			<div class="text-xl font-semibold italic">{{ order.restaurant.restaurantName }}</div>
			<div class="italic">{{ $filters.formatDate(order.lastDateAccepted) }}</div>
		</div>
		<div>
			<div class="text-lg italic mt-2">
				Order <b>#{{ formatOrderId }}</b>
			</div>
			<div v-if="order.enableCookingTime" class="text-lg italic mt-2">
				Duhet të jet e gatuar në orën: <b>{{ shouldBeCooked }}</b>
			</div>
			<div v-if="order.paymentMethod">
				<div><b>Mënyra e pagesës:</b> {{ $filters.capitalization(order.paymentMethod.paymentType) }}</div>
			</div>
			<div>
				<div><b>Address:</b> {{ order.address }} ({{ order.addressDetails }})</div>
			</div>
			<div><b>Phone:</b> {{ order.phone }}</div>
		</div>
		<div class="divider" />
		<div class="flex flex-col gap-1">
			<div class="flex items-start justify-between gap-3" v-for="(item, index) in order.items" :key="index">
				<div class="">{{ item['itemName'] }}</div>
				<div class="flex items-center flex-shrink-0 justify-between max-w-sm gap-2">
					<div>x {{ item['quantity'] }}</div>
					<div>
						{{ $filters.formatCurrency(item['itemPrice'] * item['quantity'], order.currency) }}
					</div>
				</div>
			</div>
			<div>{{ order.description }}</div>
		</div>
		<div class="divider" />
		<div class="flex flex-col">
			<div class="flex justify-between">
				<span>Subtotal</span>
				<span>{{ $filters.formatCurrency(order.totalNet, order.currency) }}</span>
			</div>
			<div class="flex justify-between">
				<span>Transport</span>
				<span>{{ $filters.formatCurrency(order.transportCost, order.currency) }}</span>
			</div>
			<div v-if="order.discountValue" class="flex justify-between">
				<span>Discount</span>
				<span> - {{ $filters.formatCurrency(order.discountValue, order.currency) }} </span>
			</div>
			<div class="flex justify-between">
				<span>Total</span>
				<span class="font-semibold">{{ $filters.formatCurrency(order.total, order.currency) }}</span>
			</div>
		</div>
		<p class="mt-4 italic">*Ky nuk eshte kupon fiskal</p>
	</div>
</template>

<script>
	import OrderService from '@/services/OrderService';
	export default {
		name: 'PrintOrderModal',
		data: () => ({
			order: {
				orderID: 0,
				restaurant: {},
				customer: {},
				courierUser: {},
				address: {},
				items: [],
				statusLogs: [],
				status: 'PENDING',
			},
		}),
		computed: {
			formatOrderId() {
				return OrderService.formatOrderId(this.order.orderID);
			},
			shouldBeCooked() {
				const date = new Date(this.order.lastDateAccepted);
				date.setMinutes(date.getMinutes() + this.order.totalCookingTime - 5);
				return this.$filters.getShortTime(date);
			},
		},
		methods: {
			print() {
				// Get HTML to print from element
				const prtHtml = document.getElementById('printSection').innerHTML;

				// Get all stylesheets HTML
				let stylesHtml = '';
				for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
					stylesHtml += node.outerHTML;
				}
				// Open the print window
				const WinPrint = window.open(
					this.order.restaurant.restaurantName,
					'',
					'left=0,top=0,width=700,height=600,toolbar=0,scrollbars=0,status=0'
				);

				WinPrint.document.write(`<!DOCTYPE html>
          <html lang="en">
            <head>
            <title>Print Order</title>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

				window.setTimeout(() => {
					WinPrint.document.close();
					WinPrint.focus();
					WinPrint.print();
					WinPrint.close();
				}, 50);
			},
		},
		mounted() {
			this.emitter.on('printOrder', (order) => {
				this.order = order;
				this.$nextTick(() => {
					this.print();
				});
			});
		},
		beforeUnmount() {
			this.emitter.off('printOrder', null);
		},
	};
</script>

<style lang="scss" scoped>
	.divider {
		@apply my-2;
		border-bottom: 1px dashed black;
	}

	.printSection {
		display: none;
	}

	@page {
		size: auto;
	}

	@print {
		@page :footer {
			display: none;
		}

		@page :header {
			display: none;
		}
	}

	@media print {
		@page {
			margin-top: 20px;
			margin-bottom: 20px;
		}
		body {
			padding-top: 72px;
			padding-bottom: 72px;
		}
		.divider {
			@apply my-2;
			border-bottom: 1px dashed black;
		}

		.printSection {
			display: none;
		}
	}
</style>
